define(
    'AAMS.OffersExtension.Offers.SignUp.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function OffersSignupModel() {
            SCModel.call(this);
            // Define properties of the model.
            this.urlRoot = function() {
                return Utils.getAbsoluteUrl(
                    getExtensionAssetsPath("services/OffersSignup.Service.ss")
                )
            }

            this.validation = function() {
                return {
                    
                    email: [
                        {
                            required: true,
                            msg: 'Email Address is Required'
                        },
                        {
                            pattern: 'email',
                            msg: 'Valid email address is required'
                        }
                    ],
                    firstname: {
                        required: true,
                        msg: Utils.translate('First Name is Required')
                    },
                    lastname: {
                        required: true,
                        msg: Utils.translate('Last Name is Required')
                    },

                    custentity_destination_country: {
                            fn: function(val) {
                               //console.log(val)
                               if(val == 'Select one' || val == undefined)
                                return Utils.translate('Country is Required');
                            }
                        },
                    custentity_customer_state: {
                         fn: function(value,name,form) {
                           //console.log(form.custentity_destination_country)

                           if(form.custentity_destination_country != undefined && (form.custentity_customer_state == undefined || form.custentity_customer_state == 'Select one'))
                            return Utils.translate('State is Required');                  
                        }
                    }
                    , phone: {
                        required: true,
                        msg: Utils.translate('Phone Number is Required')
                    }
                }
            }
        }

        OffersSignupModel.prototype = Object.create(SCModel.prototype);

        OffersSignupModel.prototype.constructor = OffersSignupModel;

        // Return the AMD constructor.
        return OffersSignupModel;
    }
);
